<script lang="ts">
  import AUStack from "component_library/components/svelte/ui/AUStack.svelte"
  import fullLogo from "icons/autouncleLogoUnconstrainedWhite.svg?raw"
  import compactLogo from "icons/autouncle.svg?raw"
  import Svg from "./Svg.svelte"
  import { colors } from "component_library/styles/theme"
  import AUBrandText from "component_library/components/svelte/ui/AUBrandText.svelte"
  import { getContext } from "svelte"
  import type { Texts } from "website_script/types/texts"
  import type { Settings } from "website_script/types/settings"

  export let onClick: (e: MouseEvent) => void = () => undefined
  export let onKeydown: (e: KeyboardEvent) => void = () => undefined
  export let showHeader: boolean = true
  const {
    conversionBox: { insights },
  } = getContext<Texts>("texts")

  const { auCarUrl } = getContext<Settings>("settings")
  // If we are rendering the Conversion Box, we have a car url
  const vdpUrl = auCarUrl!
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
  class="au-insights-box"
  on:click={onClick}
  on:keydown={onKeydown}
  {...$$restProps}
>
  {#if showHeader}
    <div class="au-insights-box__header">
      <a
        href={vdpUrl}
        target="_blank"
        class="au-insights-box__header-link"
        on:click={(e) => e.stopPropagation()}
      >
        <AUStack layout="horizontal" alignItems="center" gap="xs">
          <div>
            <Svg
              alt="AutoUncle"
              data={fullLogo}
              fill={colors.white}
              class="au-full-logo"
              height="10"
            />
            <Svg
              alt="AutoUncle"
              data={compactLogo}
              class="au-compact-logo"
              fill={colors.white}
              height="10"
            />
          </div>

          <div class="au-insights-box__header-title">
            <AUBrandText>{insights}</AUBrandText>
          </div>
        </AUStack>
      </a>
    </div>
  {/if}

  {#if $$slots.featured}
    <div class="au-insights-box__featured">
      <AUStack
        layout="horizontal"
        alignItems="center"
        justifyContent="space-between"
        gap="md"
      >
        <slot name="featured" />
      </AUStack>
    </div>
  {/if}

  <AUStack gap="md">
    {#if $$slots.highlights}
      <div class="au-car-highlights">
        <div class="au-car-highlights__container">
          <slot name="highlights" />
        </div>
      </div>
    {/if}
    {#if $$slots.actions}
      <div class="au-insights-box__actions">
        <slot name="actions" />
      </div>
    {/if}
    {#if $$slots.content}
      <div class="au-insights-box__content">
        <slot name="content" />
      </div>
    {/if}
  </AUStack>
</div>

<style>
  .au-insights-box {
    font-family: var(--au-text-font-family-primary);

    --au-insights-box-border-radius: calc(
      var(--au-border-radius-default) + var(--au-border-radius-sharp)
    );
    --au-line-clamp: 3;

    border: 1px solid var(--au-line-color-neutral);
    border-radius: var(--au-insights-box-border-radius);
    box-shadow: var(--au-box-default-box-shadow);
    background-color: var(--au-background-default);

    @container (min-width: 420px) {
      --au-line-clamp: 2;
    }

    container-type: inline-size;
  }

  .au-insights-box__header {
    background: linear-gradient(90deg, #74d2eb 0%, #0aafdc 100%);
    border-top-right-radius: var(--au-insights-box-border-radius);
    border-top-left-radius: var(--au-insights-box-border-radius);
    padding: 6px var(--au-spacing-lg);
    color: var(--au-button-primary-color);
  }

  .au-insights-box__header-link {
    display: inline-block;
    color: inherit;
    text-decoration: none;
  }

  .au-insights-box__header-link:hover {
    color: inherit;
  }

  .au-insights-box__header-link:focus-visible {
    outline-offset: 1px;
  }

  .au-insights-box__header-title {
    font-size: var(--au-text-body-small-font-size);
    line-height: 20px; /* this does not match any line height tokens */
  }

  .au-insights-box__featured {
    padding: var(--au-spacing-lg) var(--au-spacing-lg) 0;
  }

  .au-insights-box__actions {
    padding: 0 var(--au-spacing-lg) var(--au-spacing-lg);
  }

  .au-insights-box__content {
    padding: var(--au-spacing-lg);
  }

  .au-car-highlights {
    padding: var(--au-spacing-md) var(--au-spacing-lg) 0;
  }

  .au-car-highlights__container {
    position: relative;
    height: calc(
      var(--au-text-body-small-line-height) * var(--au-line-clamp, 2)
    );
    overflow: hidden;
  }

  :global([data-highlights-no="1"]) .au-car-highlights__container {
    height: auto;
  }
</style>
